<div [style]="outerCssConfig">
  @if (isFetching) {
  <div class="" [innerHTML]="fetchingTemplate | safeHtml"></div>
  } @else if (imgPath && showImageViewer) {
  <finxone-web-frontend-image-widget
    [imgPath]="imgPath"
    [showImage]="true"
    [showExpandView]="showExpandDocument"
  ></finxone-web-frontend-image-widget>
  } @else {
  <div class="" [innerHTML]="noDocumentTemplate | safeHtml"></div>
  }
</div>
